import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { DatePickerModule } from "primeng/datepicker";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { InputTextModule } from "primeng/inputtext";
import { MenuModule } from "primeng/menu";
import { PaginatorModule } from "primeng/paginator";
import { PanelMenuModule } from "primeng/panelmenu";
import { SelectModule } from "primeng/select";
import { TabsModule } from "primeng/tabs";
import { TooltipModule } from "primeng/tooltip";
import { SearchColumnComponent } from "../search/search-column.component";
import { ErrorBadgeComponent } from "./error-badge.component";
import { FormGroupComponent } from "./form-group.component";
import { ModalComponent } from "./modal/modal.component";
import { ModalSelectComponent } from "./modal-select.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { NextaCrudModule } from "./nexta-crud/crud.module";
import { SidenavComponent } from "./sidenav/sidenav.component";

const DIRECTIVES = [
	ModalComponent,
	NavbarComponent,
	SidenavComponent,
	ErrorBadgeComponent,
	FormGroupComponent,
	SearchColumnComponent,
	ModalSelectComponent,
];

@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		RouterModule,
		BrowserAnimationsModule,
		ButtonModule,
		CalendarModule,
		DatePickerModule,
		DropdownModule,
		InputNumberModule,
		InputTextModule,
		MenuModule,
		PanelMenuModule,
		PaginatorModule,
		SelectModule,
		TabsModule,
		TooltipModule,
		NextaCrudModule,
	],
	declarations: [...DIRECTIVES],
	exports: [
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		RouterModule,
		ButtonModule,
		CalendarModule,
		DatePickerModule,
		DropdownModule,
		InputNumberModule,
		InputTextModule,
		MenuModule,
		PanelMenuModule,
		PaginatorModule,
		SelectModule,
		TabsModule,
		TooltipModule,
		NextaCrudModule,
		...DIRECTIVES,
	],
})
export class SharedModule {}
